import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { GeographicDistribution } from '../../models/Common';
import { LeoImagesSplitsPath } from '../../resources/api-constants';
import { useTranslation } from 'react-i18next';

const maxHeight = 54;
const minHeight = 3
const heightBreakPoint = 30;

export interface IGeographicDistributionGraphProps {
    distribution: GeographicDistribution[];
    hideProportion?: boolean;
}

const GeographicDistributionGraph: React.FC<IGeographicDistributionGraphProps> = ({ distribution, hideProportion }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();
    let data = [...distribution];
    data.sort((a, b) => b.proportion - a.proportion);
    if (data.length > 5) {
        data = data.slice(0, 5);
    }
    const max = Math.max(...data.map(i => i.proportion));
    return <Box display={"flex"} justifyContent={"stretch"} alignItems={"end"} gap={"8px"}>
        {data.map((item) => {//lighten(theme.palette.leo.tone5, 0.45 * Math.log1p(5 * index / data.length))
            const height = maxHeight //hideProportion ? maxHeight : ((maxHeight - minHeight) / (max) * (item.proportion) + minHeight);
            return <Box display={"flex"} justifyContent={"end"} alignItems={"center"} flexDirection={"column"} width={`64px`} key={`zone-${item.zone}`}>
                <Box display={"flex"} flexDirection={"column"} justifyContent={hideProportion ? "center" : "flex-end"} alignItems={"center"} width={"100%"} height={height} bgcolor={theme.palette.primary.light} borderRadius={"1.5px"} padding={"6px"} gap={"6px"}>
                    <Box display={"flex"} justifyContent={"space-evenly"} alignItems={"center"} maxWidth={"90%"}>
                        {/* <img src={`${LeoImagesSplitsPath}/${item.icon}`} style={{ width: isSmall ? "12px" : "20px", height: isSmall ? "12px" : "20px" }} alt={`${t('A11yGeographicAlt')} ${item.zone}`} /> */}
                        <Typography fontSize={"12px"} lineHeight={"12px"} fontWeight={"500"} textAlign={"center"} color={theme.palette.primary.dark} >{item.zone}</Typography>
                    </Box>
                    {!hideProportion && <Box display={"flex"} bgcolor={theme.palette.primary.dark} padding={"1px 7px"} borderRadius={"10px"}>
                        <Typography fontSize={"14px"} lineHeight={"12px"} fontWeight={"500"} color={theme.palette.common.white}>{Math.floor(item.proportion * 100)}%</Typography>
                    </Box>}
                </Box>
            </Box>
        })}
    </Box>;
}

export default GeographicDistributionGraph;